<div class="row mb-2">
    <div class="col pl-0">
      <div widget class="card border-0 box-shadow">
        <div class="card-header transparent  text-muted">
          <h4 class="mb-0 font-header">Physician Code</h4>
        </div>
        <div class="card-body  widget-body pb-0 pt-2 mb-4">
        </div>
      </div>
    </div>
  </div>
  <div class="row mb-2">
    <div class="col pl-0">
      <div widget class="card border-0 box-shadow">
        <div class="card-body  widget-body pt-2">
          <ejs-grid #gridPhysician [dataSource]='data | async' [allowSorting]='true' [allowResizing]='true'
            [allowPaging]='true' [pageSettings]='initialPage' [filterSettings]='filterSettings' [allowFiltering]='true'
            [showColumnChooser]='true' (dataStateChange)='dataStateChange($event)' (resizeStop)="onResize($event)"
            (actionBegin)="onActionCompletePhysician($event)">
            <e-columns>
              <e-column minWidth=100 field="clinicName" headerText="Clinic Name">
                <ng-template #filterTemplate let-data>
                  <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                </ng-template>
              </e-column>
              <e-column minWidth=100 field="physicianName" headerText="Physican Name">
                <ng-template #filterTemplate let-data>
                  <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                </ng-template>
              </e-column>
              <e-column minWidth=100 field="npi" headerText="NPI" type="string">
                <ng-template #filterTemplate let-data>
                  <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                </ng-template>
              </e-column>
              <e-column minWidth=100 field="clinicPhone" headerText="Physican Phone" type="string">
                <ng-template #filterTemplate let-data>
                  <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                </ng-template>
              </e-column>
              <e-column minWidth=100 field="clinicAddress" headerText="Physican Address" type="string">
                <ng-template #filterTemplate let-data>
                  <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                </ng-template>
              </e-column>
              <e-column minWidth=100 *ngIf="isShowPhysician" headerText="Select" uid="action" textAlign="center"
                [showInColumnChooser]='false'>
                <ng-template #template let-data *ngIf="isShowPhysician">
                  <input type="radio" (change)="isRadioSelected(data)">
                </ng-template>
              </e-column>
              <e-column width="50" [showInColumnChooser]='false'>
                <ng-template #headerTemplate let-data>
                  <div class="d-none d-lg-block">
                    <span id='show' (click)="showGridColumns()"><i class="fa fa-cog fa-lg" aria-hidden="true"> </i></span>
                  </div>
                </ng-template>
              </e-column>
            </e-columns>
          </ejs-grid>
        </div>
      </div>
    </div>
  </div>
  